<!-- <div class="disease-wrapper" style="margin-top: 5%;">
  
    <div class="container">
      <div class="row">
        <h1 class="page-title-header">
          {{ "HEADER.Testmonial" | translate }}
        </h1>
      </div>
      <div class="slider">
        <ngx-slick-carousel
          class="carousel"
          #slickModal="slick-carousel"
          [config]="slideConfig" >
          <div ngxSlickItem *ngFor="let testmonial of testmonial" class="slide">
            <div class="card">
              <div class="card-body">
                  <div class="topimg">
             <img class="card-img-top" src="../../../assets/banner/quotation-mark.png" alt="Card image cap" />
            </div>
                <p class="card-text">
                  {{  testmonial.description | slice:0:200   }}..
                </p>
                <img class="profile" [src]="testmonial.imagePath" >
                <p class="profile-text" *ngIf="currentLang == 'en'">
                    {{testmonial.name}}
                </p>
                <p class="profile-text" *ngIf="currentLang == 'hi'">
                  {{testmonial.name}}
              </p>  <p class="profile-text" *ngIf="currentLang == 'mr'">
                {{testmonial.name}}
            </p>
                 <img class="card-img-right" src="../../../assets/banner/quotation-right-mark.svg" alt="Card image cap" />
              </div>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>
      <br>
    </div>
</div> -->
<div class="testimonials">
  <div class="section-header">
    <h2>What Parents & Schools Say</h2>
    <p>We are very glad to get good review.</p>
  </div>
  <div class="testimonials-wrapper">
    <!-- Card 1 -->
    <div class="testimonial-card">
      <img src="assets/ivimg/t2.svg" alt="Mr. Rajesh Mehta" class="testimonial-img" />
      <div class="testimonial-content">
        <p>
          Working with Innovative Vision has transformed our school activities.
          Their structured programs, skilled coaches, and focus on holistic
          child development make a real impact. Their team’s dedication and
          consistent support have made them a trusted partner in our educational
          journey.
        </p>
        <h4>Mr. Rajesh Mehta</h4>
        <span>Principal, Little Stars Preschool</span>
      </div>
    </div>
    <!-- Card 2 -->
    <div class="testimonial-card">
      <img src="assets/ivimg/t1.svg" alt="Mrs. Sunita Sharma" class="testimonial-img"/>
      <div class="testimonial-content">
        <p>
          As a parent, I’ve seen incredible growth in my child since joining
          Innovative Vision. The fun, structured sessions keep him active and
          excited for school. Their caring coaches and balanced programs truly
          support both physical and emotional development in young kids.
        </p>
        <h4>Mrs. Sunita Sharma</h4>
        <span>Parent of a 5 year old kid</span>
      </div>
    </div>
  </div>
</div>
